<tui-stepper
  [orientation]="orientation"
  [activeItemIndex]="activeItemIndex"
>
  <button
    class="step-button"
    *ngFor="let step of steps; let i = index"
    tuiStep
    [stepState]="step?.state"
    [class.clickable]="clickable !== true"
  >
    {{ step?.label }}
  </button>
</tui-stepper>
